export const ERROR_REFERENCE_LENGTH = 12

export interface ErrorReportInput {
	eventId?: string
	digest?: string
	pathname?: string
	at?: Date
}

/** Short code the reader sees and reads back to us. Sentry resolves the full event id from it. */
export function shortErrorReference({
	eventId,
	digest,
}: Pick<ErrorReportInput, "eventId" | "digest">): string | undefined {
	if (eventId) return eventId.slice(0, ERROR_REFERENCE_LENGTH)
	return digest || undefined
}

/** What the copy button puts on the clipboard: every id we can search on later. */
export function buildErrorReport({
	eventId,
	digest,
	pathname,
	at = new Date(),
}: ErrorReportInput): string {
	const lines = [
		eventId ? `event ${eventId}` : undefined,
		digest ? `digest ${digest}` : undefined,
		pathname ? `page ${pathname}` : undefined,
		`time ${at.toISOString()}`,
	]
	return lines.filter(Boolean).join("\n")
}

export const APP_ERROR_BOUNDARIES = [
	"root",
	"main",
	"drawer",
	"settings",
	"cmdk",
] as const

export type AppErrorBoundary = (typeof APP_ERROR_BOUNDARIES)[number]
